/**
 * A Petri spec is "on" under either convention: the boolean toggle ('true')
 * or the A/B variant ('B' = variant; 'A'/'false' = control). Values that are
 * already resolved booleans are passed through unchanged.
 */
export const isExperimentOn = value => value === true || value === 'true' || value === 'B';
//# sourceMappingURL=experimentUtils.js.map